import { initCertificatesPageController } from './_controller'

export function initCertificatesPage() {
  if (document.querySelector('[data-certificates]')) {
    initCertificatesPageController()
  }
}
